import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9901ce7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-message-section" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['alert', _ctx.alertMessageOptions?.classNameHeader])
    }, [
      (_ctx.alertMessageOptions?.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "alert-icon",
            src: require('../../assets/img/' + _ctx.alertMessageOptions.image + '.png')
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        innerHTML: _ctx.alertMessageOptions?.message
      }, null, 8, _hoisted_3)
    ], 2)
  ]))
}